const editWorkspace = {
    title: 'EDIT_WORKSPACE.TITLE',
    description: 'EDIT_WORKSPACE.DESCRIPTION',
    uploadBannerImage: 'EDIT_WORKSPACE.UPLOAD_BANNER_IMAGE',
    bannerAspectRatio: 'EDIT_WORKSPACE.BANNER_ASPECT_RATIO'
};

export default editWorkspace;
